const data = {
  names: {
    firstName: "EMLR",
    lastName: "Kicukiro",
  },
  title: "eChurch",
  user: "Administrator",
  menu:
    {
      home: "Home",
      allChristian: "All Christian",
      addChristian: "Add Christian",
      AddEvangelicalTeam: "Add Evangelical Team",
      AllEvangelicalTeam: "All Evangelical Team",
      addOffering: "Add Offering",
      addService: "Add Service",
      addAttendance: "Add Attendance",
      allOfferings: "All Offerings",
      allServices: "All Services",
      allAttendance: "All Attendance",
      announcement: "Announcement",
      allChildren: "All Children",
      report: "Report",
      export: "Export"
   
    },
  
    allChristianTable:
    {
      no: "No",
      full_name: "Christian Names",
      phone_number: "Phone",
      sex: "Gender",
      team: "Team",
      marital: "Marital",
      status: "Status",
      email: "Email",
      national_id: "National ID",
      province: "Province",
      district: "District",
      sector: "Sector",
      cell: "Cell",
      village: "Village",
      fatherNames: "Father's Name",
      motherNames: "Mother's Name",
      chapel: "Chapel",
      spouse: "Spouse",
      baptismDate: "Baptism Date",
      registrationDate:"Registration Date",
      dob:"Birth Date",
      isibo:"Isibo",
      education:"Education Level",
      studied:"Did you study?",
      training:"Training",
      baptized:"Baptized?",
      dobaptize:"Date of Baptize",
      godparent:"GodParent names",
      marital:"Marital Status",
      church_wedding:"Did they get married in EMLR church?",
      church_wedding_date:"Church Wedding Date",
      church_wedding_parish:"Name of wedding Church",
      civil_wedding:"Did they get civil married?",
      civil_wedding_date:"Civil Wedding Date",
      employed:"Do you have a job?",
      job_desc:"Job Description",
      ministry:"Ministrty in Church",
      evangelical_team:"Evangelical Team",
      choir_group:"Choir name",
      school:"School name",
      field_of_study:"Field Of Study",

    },
  contacts: {
    email: "info@emrlkicukiro.com",
    phone: "+250788917742",
  },
  address: {
    street: "",
    district: "Kicukiro",
    city: "Kigali",
    state: "Rwanda",
  },
};
export default data;

